export const getRandomLevelUpRewardQuantity = (level: number): number =>
  level * 10
